import script from "./TherapistLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./TherapistLayout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__